<script setup lang="ts">
import YscIconsStar from './YscIconsStar.vue'
import YscIconsStarHalf from './YscIconsStarHalf.vue'
import YscIconsStarSolid from './YscIconsStarSolid.vue'
import { ref, computed, defineModel } from '#imports'

interface Props {
  rating?: number
  small?: boolean
  editable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  rating: 5,
  small: false,
  editable: false,
})

const modelValue = defineModel<number>()

const hoveredValue = ref<number>()

const stars = computed(() => {
  return [...Array(props.rating).keys()].map((i) => {
    const value = hoveredValue.value ?? modelValue.value ?? 1

    if (i + 1 <= value) {
      return YscIconsStarSolid
    }

    if (i < value && value < i + 1) {
      return YscIconsStarHalf
    }

    return YscIconsStar
  })
})

const click = (index: number) => {
  if (props.editable && index > 0) {
    modelValue.value = index
  }
}

const mouseover = (index: number) => {
  if (props.editable) {
    hoveredValue.value = index
  }
}

const mouseleave = () => {
  hoveredValue.value = undefined
}
</script>

<template>
  <div
    class="flex items-center"
    @mouseleave="mouseleave()"
  >
    <div
      v-for="(star, index) in stars"
      :key="index"
      @click="click(index + 1)"
      @mouseover="mouseover(index + 1)"
    >
      <component
        :is="star"
        class="text-current"
        :class="[small ? 'h-5 w-5' : 'h-8 w-8', { 'cursor-pointer': editable }]"
      />
    </div>
  </div>
</template>
